// The event a rep last opened on this device, so the events list can offer a way back in when
// they leave mid-event. Kept per rep; anything older than the window is a past event, not this one.

export interface RecentEvent { id: string; name: string; openedAt: string }

export const RECENT_EVENT_WINDOW_MS = 12 * 60 * 60 * 1000;

const storageKey = (actorId: string) => `meridian:event-recent:${actorId}`;

export function rememberEventOpened(actorId: string, event: { id: string; name: string }, at = new Date()): void {
  const value: RecentEvent = { id: event.id, name: event.name, openedAt: at.toISOString() };
  try { localStorage.setItem(storageKey(actorId), JSON.stringify(value)); } catch { /* storage unavailable: best effort */ }
}

// `windowMs` bounds how old the open may be; the events list keeps the 12h default, cold-open
// landing passes Infinity because it only ever uses the event when it is live right now.
export function readRecentEvent(actorId: string, now = Date.now(), windowMs = RECENT_EVENT_WINDOW_MS): RecentEvent | null {
  if (!actorId) return null;
  try {
    const value = JSON.parse(localStorage.getItem(storageKey(actorId)) ?? 'null') as Partial<RecentEvent> | null;
    if (!value?.id || typeof value.name !== 'string' || typeof value.openedAt !== 'string') return null;
    const age = now - Date.parse(value.openedAt);
    return age >= 0 && age <= windowMs ? { id: value.id, name: value.name, openedAt: value.openedAt } : null;
  } catch { return null; }
}

export function forgetRecentEvent(actorId: string): void {
  try { localStorage.removeItem(storageKey(actorId)); } catch { /* storage unavailable: best effort */ }
}
